import * as React from "react";
import { useLocation } from "react-router-dom";
import { Box, Button, Stack } from "@mui/material";
import Typography from "@mui/material/Typography";
import useTranslation from "components/customHooks/translations";
import { Formik } from "formik";
import ServerForm from "./ServerForm";

const NewServer = () => {
  const { pathname } = useLocation();
  const translation = useTranslation();

  return (
    <Box>
      <ServerForm />
    </Box>
  );
};

export default NewServer;
